function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.509 5.668h17.324a3.338 3.338 0 013.338 3.337v11.613h-24V9.005a3.338 3.338 0 013.338-3.337zm4.42 2.863a.534.534 0 00-.66.368l-1.54 5.456a.534.534 0 00.373.66l9.116 2.504a.534.534 0 00.655-.368l1.537-5.387v-.001a.534.534 0 00-.369-.66L8.93 8.532z",
  fill: "#00ACC1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.671 20.118h23V9.005a2.838 2.838 0 00-2.838-2.837H4.51A2.838 2.838 0 001.67 9.005v11.113z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 9.514c1.84 0 3.333-1.573 3.333-3.514M24.333 9.514C22.493 9.514 21 7.941 21 6M5.333 20.514C5.333 18.574 3.841 17 2 17M21 20.514C21 18.574 22.492 17 24.333 17",
  stroke: "#371447",
  strokeWidth: 1.083
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.763 5.78V4.632c0-.632.553-1.146 1.235-1.146h4.814c.682 0 1.235.514 1.235 1.146V5.78",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.595 8.316l-.012-.003a.41.41 0 00-.497.297l-1.492 5.93a.41.41 0 00.285.494l9.41 2.686.012.003a.41.41 0 00.497-.297l1.492-5.93a.41.41 0 00-.285-.494l-9.41-2.686z",
  stroke: "#371447",
  strokeWidth: 0.843
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.852 11.93c.217.119 1.123.464 2.72 1.037l1.418 2.698.465.166-.127-2.227c.85.267 1.422.442 1.717.526.294.083.573.028.836-.166l1.16-1.32a1.132 1.132 0 00-.365-.075c-.095.002-.569.229-1.423.68l-1.587-.572 1.351-1.603c-.242-.123-.422-.175-.538-.157-.117.019-.958.374-2.525 1.066l-2.297-.818c-.09-.045-.241-.034-.452.033-.21.068-.372.157-.484.267-.129.19-.085.345.131.464z",
  fill: "#371447"
}));

function SvgVacationSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVacationSm;